<img src="assets/img/logo.svg"
     class="center">
